export const AboutUsPage = {
  Home: '/about_us.html',
  Certification: '/certification.html',
  OemSupplier: '/oem_supplier.html',
  Warranty: '/warranty.html',
  ExpertGarage: '/expert_garage.html'
};

export const FuelPumpCatalogPage = {
  Home: '/fuel_pump_catalog.html',
  PN: '/parts.html'
};

export const FuelPumpInfoPage = {
  Home: '/fuel_pump_info.html',
  Downloads: '/downloads.html',
  Electric: '/electric_fuel_pumps.html',
  Mechanical: '/mechanical_fuel_pumps.html',
  DirectInjection: '/direct_injection_fuel_pumps.html',
  SuperDuty: '/super_duty_fuel_pumps.html',
  HighPerformance: '/high_performance_fuel_pumps.html',
  UniversalTransfer: '/universal_fuel_transfer_pumps.html',
  UniversalAutomotive: '/universal_automotive_fuel_pumps.html'
};

export const ContactUsUrl = '/contact_us.html';

export const WhereToBuyUrl = '/where_to_buy.html';

export const HomeUrl = '/default.html';
